import {
  AddressToBeConfirmedIcon,
  ArrowHeadIcon,
  CustomerChoiceIcon,
  DoorLockIcon,
  EnvironmentalPhenomenonIcon,
  IconDispatcher,
  IconDispatcherProps,
  NearestGarageIcon,
  ThreeDotsIcon,
  SynergyDTIcons,
  iconDispatcherTokenKeys,
} from '@integration/alexandria-ui';
import HomeManagerIcon from './HomeManagerIcon';
import OtherIcon from './Other';
import WorldIcon from './WorldIcon';
import WrappedCheckIcon from './WrappedCheckIcon';
import { TypedMap } from 'ts/types/common.types';

const {
  BatteryIcon,
  CollisionIcon,
  DrivingIcon,
  EnginesIcon,
  FuelIcon,
  GarageIcon,
  GearIcon,
  GeolocationIcon,
  HeatingIcon: MotorHeatingIcon,
  IncidentIcon,
  KeysIcon,
  MotorcycleIcon,
  OtherIcon: MotorOtherIcon,
  OutOfRoadIcon,
  PlaceIcon,
  TowIcon,
  WarningLightIcon,
  WheelIcon,
} = SynergyDTIcons;

const ELECTRIC_TOKEN = 'mhh-icon-hm-electrics';
const PLUMBING_TOKEN = 'mhh-icon-hm-plumbing';
const SECURITY_TOKEN = 'mhh-icon-hm-security';
const MAINTENANCE_TOKEN = 'mhh-icon-hm-maintenance';
const EXPERT_TOKEN = 'mhh-icon-hm-expert';
const HEATING_TOKEN = 'mhh-icon-hm-heating';
const LOCKSMITH_TOKEN = 'mhh-icon-hm-locksmith';
const CRYSTAL_WINDOW_TOKEN = 'mhh-icon-hm-crystal-window';
const GAS_TOKEN = 'mhh-icon-hm-gas';
const TELECOMS_TOKEN = 'mhh-icon-hm-telecoms';
const ROOFING_TOKEN = 'mhh-icon-hm-roofing';
const REIMBURSEMENT_TOKEN = 'mhh-icon-hm-reimbursement';
export const iconsAdapter: TypedMap<Function | string> = {
  ALEXANDRIA_BROKEN_GLASS: 'mhh-icon-hm-glazing',
  ALEXANDRIA_DOOR_LOCK: DoorLockIcon,
  ALEXANDRIA_ELECTRIC_DAMAGES: ELECTRIC_TOKEN,
  ALEXANDRIA_ENVIRONMENTAL_PHENOMENON: EnvironmentalPhenomenonIcon,
  ALEXANDRIA_PILED_COINS: REIMBURSEMENT_TOKEN,
  ALEXANDRIA_PLUMBER: PLUMBING_TOKEN,
  ALEXANDRIA_SECURITY_SURVEILLANCE: SECURITY_TOKEN,
  ALEXANDRIA_TECHNICAL_SERVICE: MAINTENANCE_TOKEN,
  ALEXANDRIA_THREE_DOTS: ThreeDotsIcon,
  ACCOUNT_EXPERT: EXPERT_TOKEN,
  ACCOUNT_EXPERT_2: EXPERT_TOKEN,
  ACCOUNT_EXPERT_3: EXPERT_TOKEN,
  ALBANIL: 'mhh-icon-hm-mason',
  ANTENISTA: 'mhh-icon-hm-antennist',
  ANTENNIST: 'mhh-icon-hm-antennist',
  ARROW_HEAD_ICON: ArrowHeadIcon,
  AWNINGS: 'mhh-icon-hm-store',
  BUILDER: 'mhh-icon-hm-mason',
  CALEFACCION: HEATING_TOKEN,
  CAMION_DESATASCOS: 'mhh-icon-hm-truck-unlock',
  CARPENTER: 'mhh-icon-hm-carpenter',
  CARPENTER_METAL: 'mhh-icon-hm-carpenter-metal',
  CARPETER: 'mhh-icon-hm-carpet-maker',
  CARPINTERO: 'mhh-icon-hm-carpenter',
  CARPINTERO_METAL: 'mhh-icon-hm-carpenter-metal',
  CERRAJERO: LOCKSMITH_TOKEN,
  CERRAJERO_APERTURAS: LOCKSMITH_TOKEN,
  CERTIFICADOR_ENERGETICO: 'mhh-icon-hm-energy-certifier',
  CLEANING: 'mhh-icon-hm-cleaning',
  CRISTALERO: CRYSTAL_WINDOW_TOKEN,
  CUSTOMER_CHOICE: CustomerChoiceIcon,
  CUSTOMER_CHOICE_TBD: AddressToBeConfirmedIcon,
  DEFAULT: MAINTENANCE_TOKEN,
  DIGGER: 'mhh-icon-hm-digger',
  ELECTRICISTA: ELECTRIC_TOKEN,
  ELECTRICAL_TECHNICIAN: ELECTRIC_TOKEN,
  ENERGY_CERTIFIER: 'mhh-icon-hm-energy-certifier',
  ENMOQUETADOR: 'mhh-icon-hm-carpet-maker',
  FONTANERO: PLUMBING_TOKEN,
  GARDNER: 'mhh-icon-hm-gardener',
  GAS: GAS_TOKEN,
  GAS_INSTALLER: GAS_TOKEN,
  GLAZIER: CRYSTAL_WINDOW_TOKEN,
  GLASSWORKER: CRYSTAL_WINDOW_TOKEN,
  HEATING: HEATING_TOKEN,
  HOME: HomeManagerIcon,
  INDEMNIBLE: REIMBURSEMENT_TOKEN,
  INDEMNIZABLE: REIMBURSEMENT_TOKEN,
  INSTALADOR_GAS: GAS_TOKEN,
  LEAK: 'mhh-icon-hm-damage',
  LIMPIEZA: 'mhh-icon-hm-cleaning',
  LOCKSMITH: LOCKSMITH_TOKEN,
  LOCKSMITH_OPENINGS: LOCKSMITH_TOKEN,
  LOZA_SANITARIA: 'mhh-icon-hm-toilet',
  MARMOLIST: 'mhh-icon-hm-marble',
  MARMOLISTA: 'mhh-icon-hm-marble',
  NEAREST_GARAGE: NearestGarageIcon,
  PAINTER: 'mhh-icon-hm-painter',
  PARQUETISTA: 'mhh-icon-hm-parksman',
  PARTICIPATOR: 'mhh-icon-hm-parksman',
  PARTNER_HANDYMAN: 'mhh-icon-hm-partner',
  PARTNER_HANDYMAN_TECH: TELECOMS_TOKEN,
  PARTNER_MANITAS: 'mhh-icon-hm-partner',
  PARTNER_MANITAS_TECNOLOGICO: TELECOMS_TOKEN,
  PERITO: EXPERT_TOKEN,
  PERITO2: EXPERT_TOKEN,
  PERITO_VERIFICADOR: EXPERT_TOKEN,
  PERSIANIST: 'mhh-icon-hm-persianist',
  PERSIANISTA: 'mhh-icon-hm-persianist',
  PEST_CONTROL: 'mhh-icon-hm-pest',
  PINTOR: 'mhh-icon-hm-painter',
  PISCINAS: 'mhh-icon-hm-pool',
  PLUMBER: PLUMBING_TOKEN,
  PLUNGER: 'mhh-icon-hm-plunger',
  POOLS: 'mhh-icon-hm-pool',
  OTHER: OtherIcon,
  REPARADOR_TEJADOS: ROOFING_TOKEN,
  REIMBURSEMENT_COMPLETED: REIMBURSEMENT_TOKEN,
  REIMBURSEMENT_COMPLETELY_APPROVED: 'mhh-icon-hm-paper-check',
  REIMBURSEMENT_CREATED: WrappedCheckIcon,
  REIMBURSEMENT_DOCUMENTS_VALIDATED: 'mhh-icon-hm-paper-attachment',
  REIMBURSEMENT_PARTIALLY_APPROVED: 'mhh-icon-hm-paper-check',
  REIMBURSEMENT_REFUSED: 'mhh-icon-hm-refused',
  ROOF: ROOFING_TOKEN,
  SANITARY_WARE: 'mhh-icon-hm-toilet',
  SECURITY_VIGILANCE: SECURITY_TOKEN,
  SERVICIO_TECNICO: MAINTENANCE_TOKEN,
  SEWER: 'mhh-icon-hm-pipe',
  TAPICERO: 'mhh-icon-hm-upholstered',
  TECHNICAL_SERVICE: MAINTENANCE_TOKEN,
  TOLDOS: 'mhh-icon-hm-store',
  TRUCK_UNLOCK: 'mhh-icon-hm-truck-unlock',
  UPHOLSTERER: 'mhh-icon-hm-upholstered',
  VIGILANCIA_SEGURIDAD: SECURITY_TOKEN,
  WORLD: WorldIcon,

  BATTERY: BatteryIcon,
  COLLISION: CollisionIcon,
  DRIVING: DrivingIcon,
  ENGINES: EnginesIcon,
  FUEL: FuelIcon,
  GARAGE: GarageIcon,
  GEAR: GearIcon,
  GEOLOCATION: GeolocationIcon,
  INCIDENT: IncidentIcon,
  KEYS: KeysIcon,
  MOTOR_HEATING: MotorHeatingIcon,
  MOTOR_OTHER: MotorOtherIcon,
  MOTORCYCLE: MotorcycleIcon,
  OUT_OF_ROAD: OutOfRoadIcon,
  PLACE: PlaceIcon,
  TOW: TowIcon,
  WARNING_LIGHT: WarningLightIcon,
  WHEEL: WheelIcon,
};

export const computableContractsIconAdapter: TypedMap<string> = {
  FIRST_QUESTION_ELECTRICS: ELECTRIC_TOKEN,
  FIRST_QUESTION_GAS: GAS_TOKEN,
  FIRST_QUESTION_GLAZING: 'mhh-icon-hm-glazing',
  FIRST_QUESTION_HEATING: HEATING_TOKEN,
  FIRST_QUESTION_LOCKS: LOCKSMITH_TOKEN,
  FIRST_QUESTION_OTHER: 'mhh-icon-hm-others',
  FIRST_QUESTION_PESTS: 'mhh-icon-hm-pest',
  FIRST_QUESTION_PLUMBING_AND_DRAINAGE: PLUMBING_TOKEN,
  FIRST_QUESTION_ROOFING: ROOFING_TOKEN,
  FIRST_QUESTION_SECURITY: SECURITY_TOKEN,
  FIRST_QUESTION_TELECOM: TELECOMS_TOKEN,
};

export const getIconByAlexandriaToken = (props: IconDispatcherProps) =>
  IconDispatcher(props);

export const isValueInAlexandriaIcons = (tokenId: string) =>
  Object.entries(computableContractsIconAdapter).some(
    entries =>
      entries[0].toLowerCase() === tokenId?.toLowerCase() ||
      entries[1].toLowerCase() === tokenId?.toLowerCase(),
  ) || iconDispatcherTokenKeys.includes(tokenId);

export const isValueInETLIcons = (tokenId: string) =>
  tokenId &&
  Object.keys(iconsAdapter).some(
    tokenKey => tokenKey.toLowerCase() === tokenId.toLowerCase(),
  );

export const isValueInSomeIcons = (tokenId: string) =>
  tokenId && (isValueInETLIcons(tokenId) || isValueInAlexandriaIcons(tokenId));

export const defaultIcon = ({ width }: { width: string }) =>
  IconDispatcher({
    iconToken: iconsAdapter['DEFAULT'] as IconDispatcherProps['iconToken'],
    size: width,
  });

export const getIconByProvider = (providerType: string) => {
  const alexandriaIconCandidate =
    typeof iconsAdapter[providerType] === 'string'
      ? (iconsAdapter[providerType] as string)
      : providerType;
  if (isValueInAlexandriaIcons(alexandriaIconCandidate)) {
    const providerMapped = computableContractsIconAdapter[
      providerType.toUpperCase()
    ]
      ? computableContractsIconAdapter[providerType.toUpperCase()]
      : alexandriaIconCandidate;
    return ({ width }: { width: string }) =>
      IconDispatcher({
        iconToken:
          providerMapped.toLowerCase() as IconDispatcherProps['iconToken'],
        size: width,
      });
  }
  return (iconsAdapter[providerType] as Function) || defaultIcon;
};
